var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BrandLogo",class:`BrandLogo--${_vm.img}`,style:({ width: `${_vm.width}px` })},[_c('img',{attrs:{"src":require("../assets/image/evtools.png"),"width":_vm.width,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }